interface Props {
  color?: string
  width?: number
  height?: number
}

export const CheckMarkIcon = ({ color = '#6F6F6F', width = 22, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5 0.5L7.0625 14.8684L0.5 8.33731"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
